/* eslint-disable */
// @ts-nocheck
import * as React from 'react';

/* ---------------------- Straight Text ---------------------- */
export const AGENCY_ROUTE = '/account-settings/agencies';
export const AGENCY_BUTTON_TEXT = 'Add New Agency';
export const AGENCY_DROPDOWN_LABEL = 'Agency Name';
export const AGENCY_MODAL_TITLE = 'Add Agency';
export const AGENCY_MODAL_EDIT_TITLE = 'Edit Agency';
export const AGENCY_MODAL_EDIT_USER_TITLE = 'Edit Agency Team Member';
export const MODAL_TITLE_RESET_TO_INHERIT = 'Are you sure?';
export const MODAL_CONFIRM_BUTTTON_RESET_TO_INHERIT = 'Yes, Reset';
export const getResetAgencyAppModalCopy = (agencyName: string = '') => (
  <span>
    Are you sure you want to reset {agencyName}'s access to inherit from its organization-level permissions? This will
    override its existing app-level permissions.
  </span>
);
export const getResetAgencyUserAppModalCopy = (agencyName: string = '') => (
  <span>
    Are you sure you want to reset this user's access to inherit from {agencyName}'s app-level permissions OR their
    organization-level permissions? This will override the user's existing app-level permissions.
  </span>
);
export const getResetAgencyUserOrgModalCopy = (agencyName: string = '') => (
  <span>
    Are you sure you want to reset this user's access to inherit from {agencyName}'s organization-level permissions? This
    will override the user's existing organization-level permissions.
  </span>
);
export const DELETE_AGENCY_CONFIRMATION_BUTTON_TEXT = 'Yes, Delete';
export const DELETE_AGENCY_MODAL_TITLE = 'Are you sure you want to delete?';
export const DELETE_AGENCY_ORG_MODAL_TEXT =
  'If you remove this agency, they will no longer be able to access this organization or any of its apps.';
export const DELETE_AGENCY_APP_MODAL_TEXT = 'If you remove this agency, they will no longer be able to access this app.';
export const AGENCY_ACCEPT_ERROR_TITLE = 'Invitation Not Accepted';
export const AGENCY_ACCEPT_ERROR_LOCKED = 'Invitation Already Accepted';
export const AGENCY_ACCEPT_ERROR_COPY = {
  NO_USER_ACCESS: (
    <span>
      Oops! You're logged in as a user who isn't able to accept this agency access invitation.
      <br />
      Please log in using the email address that received the invitation and try accepting
      <br />
      the invitation again.
    </span>
  ),
  RELATIONSHIP_LOCKED: <span>One of your teammates has already accepted this agency access invitation.</span>,
  INVITE_EXPIRED: <span>Oops! This invitation has expired. Please request a new invitation and try again.</span>,
  UNKNOWN_ERROR: (
    <span>
      Oops! Your agency access invitation couldn't be accepted. Please contact{' '}
      <a href="mailto:support@branch.io">support@branch.io</a> for assistance.
    </span>
  ),
};
export const AGENCY_ACCEPT_ERROR_CODES = {
  '403': 'NO_USER_ACCESS',
  '404': 'INVITE_EXPIRED',
  '423': 'RELATIONSHIP_LOCKED',
  '500': 'UNKNOWN_ERROR',
};
